import React from 'react';

import Storage, {T} from './Storage.js';

var ObjectListElem = React.createClass({
  getInitialState: function() {
    var properties = Storage.getConfig(this.props.configKey).properties;
    var config = Storage.getConfig(this.props.configKey).config;
    var keys = Object.keys(properties);
    var object = {};
    for (let i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (typeof this.props[key] !== undefined && (!isNaN(this.props[key]) || this.props[key])) {
        object[key] = this.props[key];
      } else {
        if (Array.isArray(properties[key].default)) {
          object[key] = properties[key].default.slice();
        } else if (typeof properties[key].default === "object") {
          object[key] = Object.assign({}, properties[key].default);
        } else {
          object[key] = properties[key].default;
        }
      }
    }
    var state = {
      object: object, 
      properties: properties,
      config: config,
      inSelection: this.props.inSelection
    };
    return state;
  },

  componentWillReceiveProps: function(props) {
    var object = this.state.object;
    var keys = Object.keys(this.state.properties);
    for (let i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (typeof props[key] !== "undefined" && (isNaN(props[key]) || props[key])) {
        object[key] = props[key];
      }
    }
    this.setState({object: object, inSelection: props.inSelection});
  },

  handleClick: function (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onView(this.state.object);
  },

  handleEdit: function (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onEdit(this.state.object);
  },

  handleDestroy: function (e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.onDelete(this.state.object);
  },

  onCheckboxClick: function (e) {
    e.stopPropagation();
    this.props.onSelect(this.state.object.id, !this.state.inSelection);
  },

  render: function() {
    var thisView = this;
    var cells = Object.keys(this.state.properties).map(key => {
      const adminGroup = !!((this.props.user || {}).user_group || {}).admin;
      if (thisView.state.properties[key].adminGroup && !adminGroup) {
        return null;
      }
      if (!thisView.state.properties[key].width) {
        return null;
      }
      var displayString = thisView.state.object[key];
      if (thisView.state.properties[key].type === "select") {
        if (displayString && typeof displayString !== "string") {
          let displayKey = thisView.state.properties[key].displayField || "name";
          displayString = displayString[displayKey];
        }
      }
      if (thisView.state.properties[key].type === "address") {
        displayString =  
        (displayString["locality"] ? displayString["locality"] : "") + ' ' +
        (displayString["street"] ? displayString["street"] : "") + ' ' +
        (displayString["other"] ? displayString["other"] : "");
      }
      if (thisView.state.properties[key].type === "checkbox") {
        displayString = displayString ? T("display_yes") : T("display_no");
      }
      if (thisView.state.properties[key].type === "multi") {
        let displayKey = thisView.state.properties[key].displayField || "name";
        var labels = displayString.map(function(elem){
          return elem[displayKey];
        });
        displayString = labels.join(", ");
      }
      return (
        <td key={key}>{displayString}</td>
      )
    });
    var selectColumn = null;
    if (this.props.needSelect) {
      selectColumn = 
      <td onClick={this.onCheckboxClick}>
        <input 
          type="checkbox"
          checked={this.state.inSelection}
        />
      </td>
    }
    var editButton = <td><a className="btn button-edit" onClick={this.handleEdit}>{T("button_edit")}</a></td>;
    var deleteButton = <td><a className="btn button-delete" onClick={this.handleDestroy}>{T("button_delete")}</a></td>;
    if(thisView.state.object.deleted) {
      editButton = <td/>
      deleteButton = <td><a 
        className="btn button-delete"
        onClick={function(e){e.preventDefault();e.stopPropagation();}}
        disabled={true}
      >{T("button_deleted")}</a></td>;
      if (selectColumn) {
        selectColumn = 
        <td onClick={function(e){e.stopPropagation();}}>
          <input 
            type="checkbox"
            disabled={true}
            checked={this.state.inSelection}
          />
        </td>
      }
    }
    if (this.props.preset) {
      editButton= null;
      deleteButton = null;
    }
    return (
      <tr onClick={this.handleClick}>
        {selectColumn}
        {cells}
        {editButton}
        {deleteButton}
      </tr>
    );
  }
});

export default ObjectListElem;



// WEBPACK FOOTER //
// ./src/ObjectListElem.js